import { render, staticRenderFns } from "./StepFinal.vue?vue&type=template&id=519d4ec1&scoped=true"
import script from "./StepFinal.vue?vue&type=script&lang=js"
export * from "./StepFinal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519d4ec1",
  null
  
)

export default component.exports